(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mj-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mj-language-dropdown')) {
    customElements.define('mj-language-dropdown', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const details = this.querySelector('details');
        const trigger = this.querySelector('summary');
        const options = [...this.querySelectorAll('button[name="language_code"]')];
        if (!details || !trigger || !options.length) return;

        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) details.open = false;
        }, { signal });
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            details.open = false;
            trigger.focus();
            return;
          }
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = options.indexOf(document.activeElement);
          details.open = true;
          let next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = options.length - 1;
          else if (index < 0) next = event.key === 'ArrowUp' ? options.length - 1 : 0;
          else next = (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options[next].focus();
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
